/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({"data":{"categories":{"cardinal":["one","other"],"ordinal":["other"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const n = Math.abs(parseFloat(numStr));
    if (isOrdinal) {
    }
    else {
        if (n === 1)
            return "one";
    }
    return "other";
}},"locale":"fur"})
} else {
  (globalThis.__FORMATJS_PLURALRULES_DATA__ = globalThis.__FORMATJS_PLURALRULES_DATA__ || []).push({"data":{"categories":{"cardinal":["one","other"],"ordinal":["other"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const n = Math.abs(parseFloat(numStr));
    if (isOrdinal) {
    }
    else {
        if (n === 1)
            return "one";
    }
    return "other";
}},"locale":"fur"})
}
